import React from 'react'
import { TableWrapper } from './Table'
import { Table } from 'antd'

/**
 * @param {import('antd').TableProps} param0 
 * @returns 
 */
const TableComponent = ({...props}) => {
  return (
    <TableWrapper>
      <Table 
        className={`customTable ${props.className || ''}`} 
        rowClassName={(record, index) => {
          const customBg = index % 2 !== 0 ? 'custom-bg-row' : ''
          const originalClass = props.rowClassName 
            ? (typeof props.rowClassName === 'function' ? props.rowClassName(record, index) : props.rowClassName) 
            : ''
          return `${customBg} ${originalClass}`.trim()
        }}
        {...props} 
      />
    </TableWrapper>
  )
}

TableComponent.propTypes = {}

export default TableComponent
